import { useTranslation } from 'react-i18next'
import { DownOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { OrderKeys, subsidySumKey } from 'sections/LKSection/modules/OrderModule/data'
import { SubsidyHexType } from 'sections/LKSection/modules/OrderModule/types'
import { getOrderModuleKey } from 'sections/LKSection/modules/OrderModule/utils'
import { Info } from 'components/ui/Info/Info'
import { Collapse, Dropdown, Flex, Link, Space, Text } from 'components/uiKit'

type SubsidyTypeInfoProps = {
  type?: 'dropdown' | 'collapse'
}
export const SubsidyTypeInfo = ({ type = 'collapse' }: SubsidyTypeInfoProps) => {
  const { t } = useTranslation()

  const getKey = (key: string) => `${OrderKeys.locationStep}.${key}`

  return (
    <>
      {type === 'dropdown' ? (
        <Dropdown
          menu={{
            items: [
              {
                type: 'group',
                label: <SubsidyInfo maxWidth={400} />,
              },
            ],
          }}
          placement="bottomLeft"
        >
          <Link>
            <Space size={4}>
              {t(getKey('Описание типов субсидий'))} <DownOutlined />
            </Space>
          </Link>
        </Dropdown>
      ) : (
        <Collapse
          items={[
            {
              label: t(getKey('Описание типов субсидий')),
              children: <SubsidyInfo />,
            },
          ]}
        />
      )}
    </>
  )
}

const SubsidyInfo = ({ maxWidth }: { maxWidth?: number | string }) => {
  const { appStore } = useStore()
  const { t } = useTranslation()

  const country = appStore.companyCountry
  const sumKey = subsidySumKey[country]

  const getKey = (key: string) => `${OrderKeys.locationStep}.${key}`

  return (
    <Info disableMargin>
      <Flex vertical gap={8} style={{ maxWidth }}>
        <Flex vertical>
          <Text>{t(`${OrderKeys.orderModule}.${SubsidyHexType.guaranteedIncome}`)}</Text>
          <Text>{t(getKey('Доплатим разницу'))}</Text>
        </Flex>
        <Flex vertical>
          <Text>{t(getKey('Единоразовая субсидия за оборот'))}</Text>
          <Text>
            {t(getKey('Это разовая выплата'))} {t(getOrderModuleKey(sumKey))}
          </Text>
        </Flex>
      </Flex>
    </Info>
  )
}
